import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ConfigService} from './config.service';

const InterceptorCacheHeader = 'X-Cache-Interceptor';
const headers = new HttpHeaders().set(InterceptorCacheHeader, '');

@Injectable()
export class MasterDataService {

     masterData: any;
     apiUrl: string;

  constructor(private httpClient: HttpClient, private configService: ConfigService) {
  }

  async loadMasterData() {
    this.apiUrl = this.configService.apiBaseUrl + 'MasterDataServlet?reportType=getMasterData';
    
    const data = await this.httpClient.get<any>(this.apiUrl).toPromise();
    if (data === null) {
      alert('Load master data failed. Please contact to administrator or try after some time');
      return;
    }
    this.setMasterData(data);
  }

  setMasterData(masterData: any) {
    this.masterData = masterData;
  }

  getMasterData() {
    return this.masterData;
  }



}
